<script>
export default {
	name: 'TText',
	inheritAttrs: false,
	computed: {
		text() {
			let style = '';
			for (let attr in this.$attrs) {
				switch (attr) {
				case 'bold': {
					style += 'font-weight: 600;';
					break;
				}
				case 'color': {
					style += `color: ${this.$attrs[attr]};`;
					break;
				}
				case 'size': {
					style += `font-size: ${this.$attrs.size};`;
					break;
				}
				case 'weight': {
					style += `font-weight: ${this.$attrs.weight};`;
					break;
				}
				default: break;
				}
			}
			return style;
		},
		'label'() {
			return 'font-size: 16px; font-weight: 600; color: #234361;';
		},
		'smallHeading'() {
			return 'font-size: 11px; font-weight: 600; color: #66788a; text-transform: uppercase;';
		}
	},
	render(createElement) {
		return createElement('span', { style: this.text }, this.$scopedSlots.default ? this.$scopedSlots.default({ label: this['label'],smallheading: this.smallHeading }) : '');
	}
};
</script>

<style scoped>
span {
	font-family: SFProText, sans-serif;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	letter-spacing: normal;
	line-height: 1.33;
}
</style>
